// eslint-disable-next-line import/prefer-default-export
export const authErrors = {
  userNotFound: 'auth/user-not-found',
  userWrongPassword: 'auth/wrong-password',
  userDisabled: 'auth/user-disabled',
};
